export enum ImagePickerSourceHint {
    CameraOnly = "CameraOnly",
    Any = "Any",
}
